import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Text, Stepper, Flex, Button, Group, Avatar, Loader, Select, SimpleGrid, NumberInput, Grid, Textarea, TextInput, Card, NumberFormatter, Badge, Paper, Switch, Radio, Image, CheckIcon } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { IconShoppingCart, IconCashBanknote, IconCubeSend, IconChecklist, IconCircleCheck, IconCheck } from '@tabler/icons-react'
import { useDebouncedCallback } from '@mantine/hooks'
import { addOrder } from '../../../../services/orders'
import { getListUsers } from '../../../../services/users'
import { getAllCountryList } from '../../../../services/location'
import { orderCategory, currencyUnit } from '../../../../helper/master-unit'
import { validation } from '../../../../plugins/validation'
import ImgCatalogList from '../../../../assets/img/images/product-lists.png'
import ImgFormLayout from '../../../../assets/img/images/form-layouts.png'
import ImgTables from '../../../../assets/img/images/tables.png'
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { notificationSuccess, notificationError } from '../../../../component/ui/Notifications'

const defaultMethodProduct = [
  {
    title: 'Add Form Catalog',
    caption: 'Add products from the asiacommerce catalog with up to 60,000 products.',
    image: ImgCatalogList,
    route: 'catalog'
  },
  {
    title: 'Add Manually',
    caption: 'Add product manually to order with manual input.',
    image: ImgFormLayout,
    route: 'form'
  },
  {
    title: 'Bulk Upload from Excel',
    caption: 'Add bulk product from excel.',
    image: ImgTables,
    route: 'upload'
  },
]


const defaultVal = {
  order_category: 'import',
  user_id: null,
  ordered_by_user_id: null,
  order_date: new Date(),
  currency_origin: 'IDR',
  currency_order: 'IDR',
  user_conversion: 0,
  conversion: 0,
  shipment_from: '44',
  shipment_to: '99',
  shipping_first_name: '',
  shipping_last_name: '',
  shipping_phone: '',
  shipping_company: '',
  shipping_country: '',
  shipping_state: '',
  shipping_city: '',
  shipping_address_1: '',
  shipping_address_2: '',
  billing_first_name: '',
  billing_last_name: '',
  billing_phone: '',
  billing_company: '',
  billing_country: '',
  billing_state: '',
  billing_city: '',
  billing_address_1: '',
  billing_address_2: '',
}

const formValidation = {
  order_category: {
    isError: false,
    message: ''
  },
  user_id: {
    isError: false,
    message: ''
  },
  order_date: {
    isError: false,
    message: ''
  },
  currency_origin: {
    isError: false,
    message: ''
  },
  currency_order: {
    isError: false,
    message: ''
  },
  user_conversion: {
    isError: false,
    message: ''
  },
  conversion: {
    isError: false,
    message: ''
  },
  shipment_from: {
    isError: false,
    message: ''
  },
  shipment_to: {
    isError: false,
    message: ''
  },
}

const AddOrder = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [activeStepOrder, setActiveStepOrder] = useState(0)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [stateAddProduct, setStateAddProduct] = useState(false)
  const [methodAddProduct, setMethodAddProduct] = useState('')
  const [loadingForm, setLoadingForm] = useState(false)

  const [loadingUser, setLoadingUser] = useState(true)
  const [userList, setUserList] = useState([])
  const [searchUser, setSearchUser] = useState('')

  const [loadingAgent, setLoadingAgent] = useState(true)
  const [agentList, setAgentList] = useState([])
  const [searchAgent, setSearchAgent] = useState('')

  const [loadingOriginCountry, setLoadingOriginCountry] = useState(true)
  const [originCountryList, setOriginCountryList] = useState([])
  const [searchOriginCountry, setSearchOriginCountry] = useState('')

  const [loadingDestinationCountry, setLoadingDestinationCountry] = useState(true)
  const [destinationCountryList, setDestinationCountryList] = useState([])
  const [searchDestinationCountry, setSearchDestinationCountry] = useState('')

  const submitAddOrder = async (form) => {
    setLoadingForm(true)
    const payload = {
      order_date: dayjs(form.order_date).format('YYYY-MM-DD'),
      order_code: 'Manual-1234',
      user_id: Number(form.user_id),
      ordered_by_user_id: form.ordered_by_user_id ? Number(form.ordered_by_user_id) : null,
      shipment_method: 'air',
      shipment_from: Number(form.shipment_from),
      shipment_to: Number(form.shipment_to),
      currency_origin: form.currency_origin,
      currency_order: form.currency_order,
      conversion: Number(form.conversion), // Goods Currency Rate
      user_conversion: Number(form.user_conversion), // Custom Currency Rate
      logistic_per_unit: 0,
      insurance_value: 0,
      insurance_value_order: 0,
      freight_value: 0,
      freight_value_order: 0,
      order_type: 'trading',
      order_category: 'local',
      courier: null,
      pay_custom: true,
      total_weight: 1,
      weight_unit: 'kg',
      total_cbm: 1,
      supplier: 0,
      total_logistic_charges: 1,
      total_duty: 1,
      total_wht: 1,
      total_vat: 1,
      total_custom_charges: 1,
      total_goods_value: 1,
      total_logistic_all_in: 1,
      grand_total: 1,
      order_infos: {
        shipping: {
          first_name: form.shipping_first_name,
          last_name: form.shipping_last_name,
          company: form.shipping_company,
          address_1: form.shipping_address_1,
          address_2: form.shipping_address_2,
          city: form.shipping_city,
          city_id: null,
          state: form.shipping_state,
          postcode: '',
          country: form.shipping_country,
          phone: form.shipping_phone,
        },
        billing: {
          first_name: form.billing_first_name,
          last_name: form.billing_last_name,
          company: form.billing_company,
          address_1: form.billing_address_1,
          address_2: form.billing_address_2,
          city: form.billing_city,
          city_id: null,
          state: form.billing_state,
          postcode: '',
          country: form.billing_country,
          phone: form.billing_phone,
        },
      },
      items: [],
      custom_logistic_charges: {
        amount: 0,
        vat_percentage: 0,
        details: [
          {
            group: 'Handling Charge',
            name: 'Handling Charge',
            vat: 0,
            total: 40000,
          },
          {
            group: '[Estimate] JNE Kota Surabaya to Kota Surabaya',
            name: '[Estimate] JNE Kota Surabaya to Kota Surabaya',
            vat: 0,
            total: 30000,
          },
        ],
      },
    }
    try {
      const response = await addOrder(payload)
      if (response.success) {
        const orderId = response.data.attributes.id
        notificationSuccess('Create Order Successfully', 'You have been successfully created order')
        if (stateAddProduct) {
          if (methodAddProduct === 'catalog') {
            navigate(`/order/${orderId}/add-product/catalog/${form.currency_order}`)
          } else if (methodAddProduct === 'form') {
            navigate(`/order/${orderId}/add-product/manual`)
          } else if (methodAddProduct === 'upload') {
            navigate(`/order/${orderId}`)
            notificationSuccess('Redirecting...', 'Please select upload file excel in tab products ')
          } else if (methodAddProduct === '') {
            navigate(`/order/${orderId}`)
          }
        } else {
          navigate(`/order/${orderId}`)
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Create Order Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingForm(false)
    }
    
  }

  const handleGetListUsers = useDebouncedCallback(async () => {
    setLoadingUser(true)
    const parameter = {
      'filter[name][like]': searchUser,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true
    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setUserList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUser(false)
    }
  }, 300)

  const handleGetListAgent = useDebouncedCallback(async () => {
    setLoadingAgent(true)
    const parameter = {
      'filter[name][like]': searchAgent,
      'fields[user]': 'id,name,email,active',
      'page[num]': 1,
      'page[limit]': 8,
      'sort': '-created_at',
      'active': true,
      'filter[is_agent][is]': 1,

    }
    try {
      const response = await getListUsers(parameter)
      const dataUser = response.data.data
      const remapDataUser = dataUser.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`,
          email: val.attributes.email
        }
      })
      setAgentList(remapDataUser)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingAgent(false)
    }
  }, 300)

  const handleGetListOriginCountry = useDebouncedCallback(async (originCountryId) => {
    setLoadingOriginCountry(true)
    const parameter = {
      'filter[id][is]': originCountryId,
      'filter[name][like]': searchOriginCountry,
      'page[num]': 1,
      'page[limit]': 15,
      'fields[country]': 'name,iso_code_2,currency',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setOriginCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingOriginCountry(false)
    }
  }, 300)

  const handleGetListDestinationCountry = useDebouncedCallback(async (destinationCountryId) => {
    setLoadingDestinationCountry(true)
    const parameter = {
      'filter[id][is]': destinationCountryId,
      'filter[name][like]': searchDestinationCountry,
      'page[num]': 1,
      'page[limit]': 15,
      'fields[country]': 'name,iso_code_2,currency',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setDestinationCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingDestinationCountry(false)
    }
  }, 300)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: '/order/all'
    },
    {
      label: 'Create Order',
      route: null
    },
  ]

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetListUsers()
    // eslint-disable-next-line
  }, [searchUser])

  useEffect(() => {
    handleGetListAgent()
    // eslint-disable-next-line
  }, [searchAgent])

  useEffect(() => {
    handleGetListOriginCountry()
    // eslint-disable-next-line
  }, [searchOriginCountry])

  useEffect(() => {
    handleGetListDestinationCountry()
    // eslint-disable-next-line
  }, [searchDestinationCountry])

  useEffect(() => {
    if (formData.shipment_from) {
      handleGetListOriginCountry(formData.shipment_from)
    }
    // eslint-disable-next-line
  }, [formData.shipment_from])

  useEffect(() => {
    if (formData.shipment_to) {
      handleGetListDestinationCountry(formData.shipment_to)
    }
    // eslint-disable-next-line
  }, [formData.shipment_to])

  const handleNextStep = (form) => {
    setValidationForm(formValidation)
    if (activeStepOrder === 0) {
      const validateFormStepOne = {
        order_category: form.order_category,
        user_id: form.user_id,
        order_date: form.order_date,
        currency_origin: form.currency_origin,
        currency_order: form.currency_order,
        user_conversion: `${form.user_conversion}`,
        conversion: `${form.user_conversion}`,
        shipment_from: form.shipment_from,
        shipment_to: form.shipment_to,
      }
      const isError = validation(validateFormStepOne, setValidationForm)
      if (isError) {
        return
      } else {
        nextStep()
      }
    } else if (activeStepOrder === 1) {
      const validateFormStepTwo = {
        order_category: form.order_category,
        user_id: form.user_id,
        order_date: form.order_date,
        currency_origin: form.currency_origin,
        currency_order: form.currency_order,
        user_conversion: `${form.user_conversion}`,
        conversion: `${form.conversion}`,
        shipment_from: form.shipment_from,
        shipment_to: form.shipment_to,
      }
      const isError = validation(validateFormStepTwo, setValidationForm)
      if (isError) {
        return
      } else {
        nextStep()
      }
    } else if (activeStepOrder === 2) {
      nextStep()
    }
  }

  const nextStep = () => setActiveStepOrder((current) => (current < 3 ? current + 1 : current))

  const prevStep = () => setActiveStepOrder((current) => (current > 0 ? current - 1 : current))

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const renderUserOption = ({ option, checked }) => {
    return (
      <Group flex="1" align='center' gap="xs">
        <Flex gap='sm' align='center'>
          <Avatar variant='filled' name={option.label} radius="xl" size="sm" color='red' />
          <Box>
            <Text fz={12} fw='600' lineClamp={2}>{option.label}</Text>
            <Text fz={10} fw='500' c='gray.6' lineClamp={2}>{option.email}</Text>
          </Box>
        </Flex>
        {checked && <IconCheck style={{ marginInlineStart: 'auto' }} />}
      </Group>
    )
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingFormStepOrder = () => {
    return (
      <Box mih={350}>
        <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
          <Box>
            <Select
              name='order_category'
              value={formData.order_category}
              label='Order Category'
              data={orderCategory}
              onChange={(val) => handleChangeForm('order_category', val)}
              error={validationForm.order_category.isError ? `${validationForm.order_category.message}` : ''}
              size='xs'
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <DateInput
              name='order_date'
              value={formData.order_date}
              label='Order Date'
              placeholder='Input order code order'
              valueFormat="DD/MM/YYYY"
              onChange={(val) => handleChangeForm('order_date', val)}
              error={validationForm.order_date.isError ? `${validationForm.order_date.message}` : ''}
              clearable
              withAsterisk
              size='xs'
            />
          </Box>
          <Box>
            <Select
              name='user_id'
              value={formData.user_id}
              label='User'
              data={userList}
              renderOption={renderUserOption}
              onChange={(val) => handleChangeForm('user_id', val)}
              error={validationForm.user_id.isError ? `${validationForm.user_id.message}` : ''}
              size='xs'
              searchable
              searchValue={searchUser}
              onSearchChange={setSearchUser}
              nothingFoundMessage={!loadingUser ? userList.length > 0 ? '' : 'No User Found' : loadingDataTemplate()}
              clearable
              withAsterisk
            />
          </Box>
          <Box>
            <Select
              name='ordered_by_user_id'
              value={formData.ordered_by_user_id}
              label='Agent'
              data={agentList}
              renderOption={renderUserOption}
              onChange={(val) => handleChangeForm('ordered_by_user_id', val)}
              size='xs'
              searchable
              searchValue={searchAgent}
              onSearchChange={setSearchAgent}
              nothingFoundMessage={!loadingAgent ? agentList.length > 0 ? '' : 'No Agent Found' : loadingDataTemplate()}
              clearable
            />
          </Box>
        </SimpleGrid>
      </Box>
    )
  }

  const mappingFormStepCurrency = () => {
    return (
      <Box mih={350}>
        <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
          <Box>
            <Select
              name='currency_origin'
              value={formData.currency_origin}
              label='Goods Origin Currency'
              data={currencyUnit}
              onChange={(val) => handleChangeForm('currency_origin', val)}
              error={validationForm.currency_origin.isError ? `${validationForm.currency_origin.message}` : ''}
              size='xs'
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <Select
              name='currency_order'
              value={formData.currency_order}
              label='Order Currency'
              data={currencyUnit}
              onChange={(val) => handleChangeForm('currency_order', val)}
              error={validationForm.currency_order.isError ? `${validationForm.currency_order.message}` : ''}
              size='xs'
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <NumberInput
              label={`Order Currency Rate (${formData.currency_origin} - ${formData.currency_order})`}
              value={formData.user_conversion}
              prefix={`${formData.currency_order}  `}
              onChange={(val) => handleChangeForm('user_conversion', val)}
              error={validationForm.user_conversion.isError ? `${validationForm.user_conversion.message}` : ''}
              decimalScale={2}
              fixedDecimalScale
              thousandSeparator="."
              decimalSeparator=","
              size='xs'
              withAsterisk
            />
          </Box>
          <Box>
            <NumberInput
              label="Custom Currency Rate"
              value={formData.conversion}
              prefix={`${formData.currency_order}  `}
              onChange={(val) => handleChangeForm('conversion', val)}
              error={validationForm.conversion.isError ? `${validationForm.conversion.message}` : ''}
              decimalScale={2}
              fixedDecimalScale
              thousandSeparator="."
              decimalSeparator=","
              size='xs'
              withAsterisk
            />
          </Box>
          <Box>
            <Select
              name='shipment_from'
              value={formData.shipment_from}
              label='Origin Country'
              data={originCountryList}
              onChange={(val) => handleChangeForm('shipment_from', val)}
              error={validationForm.shipment_from.isError ? `${validationForm.shipment_from.message}` : ''}
              size='xs'
              searchable
              searchValue={searchOriginCountry}
              onSearchChange={setSearchOriginCountry}
              nothingFoundMessage={!loadingOriginCountry ? originCountryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
              clearable
              withAsterisk
            />
          </Box>
          <Box>
            <Select
              name='shipment_to'
              value={formData.shipment_to}
              label='Destination Country'
              data={destinationCountryList}
              onChange={(val) => handleChangeForm('shipment_to', val)}
              error={validationForm.shipment_to.isError ? `${validationForm.shipment_to.message}` : ''}
              size='xs'
              searchable
              searchValue={searchDestinationCountry}
              onSearchChange={setSearchDestinationCountry}
              nothingFoundMessage={!loadingDestinationCountry ? destinationCountryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
              clearable
              withAsterisk
            />
          </Box>
        </SimpleGrid>
      </Box>
    )
  }

  const mappingFormStepShippingBilling = () => {
    return (
      <Box mih={500}>
        <Grid align='start' overflow='hidden' mb={20}>
          <Grid.Col span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder>
              <Text fz={18} fw={600} mb={8}>Shipping Address</Text>
              <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                <Box>
                  <TextInput
                    name='shipping_first_name'
                    value={formData.shipping_first_name}
                    label='First Name'
                    placeholder='Input first name'
                    onChange={(val) => handleChangeForm('shipping_first_name', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='shipping_last_name'
                    value={formData.shipping_last_name}
                    label='Last Name'
                    placeholder='Input last name'
                    onChange={(val) => handleChangeForm('shipping_last_name', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='shipping_phone'
                    value={formData.shipping_phone}
                    label='Phone'
                    placeholder='Input phone'
                    onChange={(val) => handleChangeForm('shipping_phone', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='shipping_company'
                    value={formData.shipping_company}
                    label='Company'
                    placeholder='Input company'
                    onChange={(val) => handleChangeForm('shipping_company', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='shipping_country'
                    value={formData.shipping_country}
                    label='Country'
                    placeholder='Input country'
                    onChange={(val) => handleChangeForm('shipping_country', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='shipping_state'
                    value={formData.shipping_state}
                    label='State'
                    placeholder='Input state'
                    onChange={(val) => handleChangeForm('shipping_state', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='shipping_city'
                    value={formData.shipping_city}
                    label='City'
                    placeholder='Input city'
                    onChange={(val) => handleChangeForm('shipping_city', val.target.value)}
                    size='xs'
                  />
                </Box>
              </SimpleGrid>
              <Box mb='sm'>
                <Textarea
                  name='shipping_address_1'
                  label='Address 1'
                  placeholder="Input address"
                  value={formData.shipping_address_1}
                  onChange={(val) => handleChangeForm('shipping_address_1', val.target.value)}
                  size='xs'
                  autosize
                  minRows={4}
                  maxRows={4}
                />
              </Box>
              <Box mb='sm'>
                <Textarea
                  name='shipping_address_2'
                  label='Address 2'
                  placeholder="Input address"
                  value={formData.shipping_address_2}
                  onChange={(val) => handleChangeForm('shipping_address_2', val.target.value)}
                  size='xs'
                  autosize
                  minRows={4}
                  maxRows={4}
                />
              </Box>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder>
              <Text fz={18} fw={600} mb={8}>Billing Address</Text>
              <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                <Box>
                  <TextInput
                    name='billing_first_name'
                    value={formData.billing_first_name}
                    label='First Name'
                    placeholder='Input first name'
                    onChange={(val) => handleChangeForm('billing_first_name', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='billing_last_name'
                    value={formData.billing_last_name}
                    label='Last Name'
                    placeholder='Input last name'
                    onChange={(val) => handleChangeForm('billing_last_name', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='billing_phone'
                    value={formData.billing_phone}
                    label='Phone'
                    placeholder='Input phone'
                    onChange={(val) => handleChangeForm('billing_phone', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='billing_company'
                    value={formData.billing_company}
                    label='Company'
                    placeholder='Input company'
                    onChange={(val) => handleChangeForm('billing_company', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='billing_country'
                    value={formData.billing_country}
                    label='Country'
                    placeholder='Input country'
                    onChange={(val) => handleChangeForm('billing_country', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='billing_state'
                    value={formData.billing_state}
                    label='State'
                    placeholder='Input state'
                    onChange={(val) => handleChangeForm('billing_state', val.target.value)}
                    size='xs'
                  />
                </Box>
                <Box>
                  <TextInput
                    name='billing_city'
                    value={formData.billing_city}
                    label='City'
                    placeholder='Input city'
                    onChange={(val) => handleChangeForm('billing_city', val.target.value)}
                    size='xs'
                  />
                </Box>
              </SimpleGrid>
              <Box mb='sm'>
                <Textarea
                  name='billing_address_1'
                  label='Address 1'
                  placeholder="Input address"
                  value={formData.billing_address_1}
                  onChange={(val) => handleChangeForm('billing_address_1', val.target.value)}
                  size='xs'
                  autosize
                  minRows={4}
                  maxRows={4}
                />
              </Box>
              <Box mb='sm'>
                <Textarea
                  name='billing_address_2'
                  label='Address 2'
                  placeholder="Input address"
                  value={formData.billing_address_2}
                  onChange={(val) => handleChangeForm('billing_address_2', val.target.value)}
                  size='xs'
                  autosize
                  minRows={4}
                  maxRows={4}
                />
              </Box>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    )
  }

  const mappingReviewOrder = () => {

    const hookDataForm = (search, valueForm, dataList) => {
      if (search && valueForm && dataList.length > 0) {
        const findData = dataList.find((val) => val.value === valueForm)
        if (findData) {
          return findData.label
        }
      }
      return ''
    }
    return (
      <Box mih={500}>
        <Text fz={18} fw={600} mb={20}>Please review your order before creating order.</Text>
        <Grid align='start' overflow='hidden' mb={20}>
          <Grid.Col span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder h={320}>
              <Text fz={18} fw={600} mb={12}>General Order</Text>
              <Card.Section withBorder inheritPadding py='md'>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Ordered By User</Text>
                  <Text fz={12} c='black' fw='600'>{hookDataForm(searchUser, formData.user_id, userList) || '-'}</Text>
                </Box>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Agent</Text>
                  <Text fz={12} c='black' fw='600'>{hookDataForm(searchAgent, formData.ordered_by_user_id, agentList) || '-'}</Text>
                </Box>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Order Category</Text>
                  <Text fz={12} c='black' fw='600' tt='capitalize'>{formData.order_category}</Text>
                </Box>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Order Date</Text>
                  <Text fz={12} c='black' fw='600'>{dayjs(formData.order_date).format('DD-MMMM-YYYY')}</Text>
                </Box>
              </Card.Section>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder h={320}>
              <Text fz={18} fw={600} mb={12}>Country & Currency</Text>
              <Card.Section withBorder inheritPadding py='md'>
                <SimpleGrid cols={2} verticalSpacing="lg" mb='xs'>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Goods Origin Currency</Text>
                    <Text fz={12} c='black' fw='600'>{formData.currency_origin}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Order Currency</Text>
                    <Text fz={12} c='black' fw='600'>{formData.currency_order}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Goods Currency Rate ({formData.currency_origin} - {formData.currency_order}) </Text>
                    <Text fz={12} c='black' fw='600'>
                      <NumberFormatter prefix={`${formData.currency_order} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={formData.user_conversion} />
                    </Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Custom Currency Rate</Text>
                    <Text fz={12} c='black' fw='600'>
                      <NumberFormatter prefix={`${formData.currency_order} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={formData.conversion} />
                    </Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Origin Country</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500'>{hookDataForm(searchOriginCountry, formData.shipment_from, originCountryList)}</Badge>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Destination Country</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500'>{hookDataForm(searchDestinationCountry, formData.shipment_to, destinationCountryList)}</Badge>
                  </Box>
                </SimpleGrid>
              </Card.Section>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder>
              <Text fz={18} fw={600} mb={12}>Shipping Address</Text>
              <Card.Section withBorder inheritPadding py='md'>
                <SimpleGrid cols={2} verticalSpacing="lg" mb='lg'>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>First Name</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_first_name || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Last Name</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_last_name || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Phone</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_phone || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Company</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_company || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Country</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_country || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>State</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_state || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>City</Text>
                    <Text fz={12} c='black' fw='600'>{formData.shipping_city || '-'}</Text>
                  </Box>
                </SimpleGrid>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Address 1</Text>
                  <Text fz={12} c='black' fw='600' h={70}>{formData.shipping_address_1 || '-'}</Text>
                </Box>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Address 2</Text>
                  <Text fz={12} c='black' fw='600' h={70}>{formData.shipping_address_2 || '-'}</Text>
                </Box>
              </Card.Section>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card shadow="sm" padding="md" radius="md" withBorder>
              <Text fz={18} fw={600} mb={12}>Billing Address</Text>
              <Card.Section withBorder inheritPadding py='md'>
                <SimpleGrid cols={2} verticalSpacing="lg" mb='lg'>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>First Name</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_first_name || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Last Name</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_last_name || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Phone</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_phone || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Company</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_company || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>Country</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_country || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>State</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_state || '-'}</Text>
                  </Box>
                  <Box>
                    <Text fz={12} c='gray.6' mb={4}>City</Text>
                    <Text fz={12} c='black' fw='600'>{formData.billing_city || '-'}</Text>
                  </Box>
                </SimpleGrid>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Address 1</Text>
                  <Text fz={12} c='black' fw='600' h={70}>{formData.billing_address_1 || '-'}</Text>
                </Box>
                <Box mb='md'>
                  <Text fz={12} c='gray.6' mb={4}>Address 2</Text>
                  <Text fz={12} c='black' fw='600' h={70}>{formData.billing_address_2 || '-'}</Text>
                </Box>
              </Card.Section>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    )
  }

  const mappingFormAddProduct = (stepOrder) => {

    const mappingFormProductMethod = (stateProduct) => {
      if (stateProduct) {

        const mappingMethodAddProduct = (dataMenu) => {
          const remapSelected = dataMenu.map((val, index) => {
            return (
              <Grid.Col span={4} key={index}>
                <Radio.Card radius="md" p='sm' mb='sm' withBorder checked={methodAddProduct === val.route} onClick={() => setMethodAddProduct(val.route)} style={{ cursor: 'pointer' }}>
                  <Card withBorder>
                    <Card.Section>
                      <Image src={val.image} height={160} fit='cover' />
                    </Card.Section>
                  </Card>
                  <Box my={10} h={50}>
                    <Text fz={14} fw={600} mb={6}>{val.title}</Text>
                    <Text fz={11} fw={500} c='dimmed'>{val.caption}</Text>
                  </Box>
                  <Flex justify='center' align='center' my={10}>
                    <Radio.Indicator icon={CheckIcon} />
                  </Flex>
                </Radio.Card>
              </Grid.Col>
            )
          })
          return remapSelected
        }

        return (
          <Box my={10}>
            <Text fz={14} fw={500}>Select Method to Add product</Text>
            <Box mt='xs'>
              <Grid align='center'>
                {mappingMethodAddProduct(defaultMethodProduct)}
              </Grid>
            </Box>
          </Box>
        )
      }
    }


    if (stepOrder === 3) {
      return (
        <Box>
          <Box mb='lg'>
            <Paper shadow="xs" withBorder p="md">
              <Switch
                checked={stateAddProduct}
                onChange={(val) => setStateAddProduct(val.currentTarget.checked)}
                label="Add Product Order"
                description="Don't worry, if you disabled this, you can add product later"
                size="sm"
              />
            </Paper>
          </Box>
          {mappingFormProductMethod(stateAddProduct)}
        </Box>
        
      )
    }
  }


  return (
    <AuthLayout>
      <Box my={20}>
        <Box mb={30}>
          <Text className={classes.titleLayout}>Create Order</Text>
        </Box>
        <Box mb='lg'>
          <Stepper active={activeStepOrder} onStepClick={setActiveStepOrder} allowNextStepsSelect={false} completedIcon={<IconCircleCheck size={20} />}>
            <Stepper.Step label="General" description="Step 1" icon={<IconShoppingCart size={20} />}>
              {mappingFormStepOrder()}
            </Stepper.Step>
            <Stepper.Step label="Country & Currency" description="Step 2" icon={<IconCashBanknote size={20} />}>
              {mappingFormStepCurrency()}
            </Stepper.Step>
            <Stepper.Step label="Shipping & Billing" description="Step 3" icon={<IconCubeSend size={20} />}>
              {mappingFormStepShippingBilling()}
            </Stepper.Step>
            <Stepper.Step label="Review & Finish" description="Step 4" icon={<IconChecklist size={20} />}>
              {mappingReviewOrder()}
            </Stepper.Step>
          </Stepper>
        </Box>
        {mappingFormAddProduct(activeStepOrder)}
        <Flex justify='space-between' align='center'>
          <Button size='xs' variant="outline" onClick={() => activeStepOrder === 0 ? navigate('/order/all') : prevStep()}>{activeStepOrder === 0 ? 'Go to Order List' : 'Prev Step'}</Button>
          <Button size='xs' variant="filled" loading={loadingForm} onClick={() => activeStepOrder < 3 ? handleNextStep(formData) : submitAddOrder(formData)}>{activeStepOrder === 3 ? 'Create Order' : 'Next Step'}</Button>
        </Flex>
      </Box>
    </AuthLayout>
  )
}

export default AddOrder